import(/* webpackMode: "eager" */ "/ml-microservice/app/globals.css");
import(/* webpackMode: "eager" */ "/ml-microservice/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/ml-microservice/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/ml-microservice/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/ml-microservice/components/ui/tooltip.tsx")